import type { FC } from "react";
import React, { useCallback, useRef, useState } from "react";
import ImageGallery from "react-image-gallery";
import cx from "classnames";

import type { Content } from "../../../types/main";
import { ImageItem } from "./components/image_item/image_item";

import pdf from "../../../images/pdf.jpeg";

type Props = {
    blur: boolean;
    data: Content;
    onChange?: (e?: any) => void;
};

export const UnitContent: FC<Props> = ({ blur, data, onChange }: Props) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const loadedImages = useRef<Record<string, boolean>>({});

    const handleScreenChange = useCallback(
        (fullscreen) => {
            setIsFullscreen(fullscreen);
            onChange?.();
        },
        [onChange]
    );

    const handleImageLoaded = useCallback(
        (event, original) => {
            const imageExists = loadedImages.current[original];
            if (!imageExists && onChange) {
                loadedImages.current[original] = true; // prevent from call again
                // image just loaded, call onChange
                onChange(event);
            }
        },
        [onChange]
    );

    const renderItem = useCallback(
        (item) => (
            <ImageItem
                description={item.description}
                fullscreen={item.fullscreen}
                handleImageLoaded={handleImageLoaded}
                isFullscreen={isFullscreen}
                original={item.original}
                originalAlt={item.originalAlt}
                originalHeight={item.originalHeight}
                originalWidth={item.originalWidth}
                originalTitle={item.originalTitle}
                sizes={item.sizes}
                srcSet={item.srcSet}
            />
        ),
        [handleImageLoaded, isFullscreen]
    );

    return (
        <div className={cx("unit", { "unit--blur": blur })}>
            <div className="unit__content">
                <ImageGallery
                    items={data.images}
                    onImageLoad={onChange}
                    onScreenChange={handleScreenChange}
                    onSlide={onChange}
                    renderItem={renderItem}
                    showFullscreenButton={true}
                    showPlayButton={false}
                    showThumbnails={!isFullscreen}
                    useBrowserFullscreen={true}
                />
                {!isFullscreen && data.file && (
                    <div className="unit__pdf">
                        <div className="unit__pdf-icon">
                            <img src={pdf} alt="" />
                        </div>
                        <div className="unit__pdf-link">
                            <a href={data.file} rel="noreferrer" target="_blank">
                                Скачать схему с объяснением
                            </a>
                        </div>
                    </div>
                )}
                {!isFullscreen && data.additionalFile && (
                    <div className="unit__pdf">
                        <div className="unit__pdf-icon">
                            <img src={pdf} alt="" />
                        </div>
                        <div className="unit__pdf-link">
                            <a href={data.additionalFile} rel="noreferrer" target="_blank">
                                Скачать приложение к схеме
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
